import React from 'react';
import styled from 'styled-components';
import t from 'prop-types';

const NavBarWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: ${props => props.navBarWidth}px;
`;

const ContentContainer = styled.div`
  margin-left: ${props => props.navBarWidth}px;
  min-height: 100vh;
  display: flex;
`;

const WithLeftNavBar = ({NavBar, children, navBarWidth = 60}) => (
  <>
    <NavBarWrapper navBarWidth={navBarWidth}>
      <NavBar />
    </NavBarWrapper>
    <ContentContainer navBarWidth={navBarWidth}>
      {children}
    </ContentContainer>
  </>
);

WithLeftNavBar.propTypes = {
  NavBar: t.func,
  children: t.node,
  navBarWidth: t.number
};

export default WithLeftNavBar;
